/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../../../Container/Container";
import AttorneyTextCards from "./AttorneyTextCards";
import AttorneySectionHeadings from "./AttorneySectionHeadings";
import attorneySectionStyle from "./attorneySectionStyle";
import BirdMapSection from "../BirdMapSection/BirdMapSection";
import TeamSection from "../../Generic/TeamSection/TeamSection";
import { Box } from "@mui/material";

type AttorneySectionProps = {
  textCards?: boolean;
  product?: "divorce" | "settlement" | "traffic" | "familyLawCase" | "contract";
  heading?: string;
  subheading?: string;
};

const AttorneySection = ({ textCards = true, product = "divorce", heading, subheading }: AttorneySectionProps) => {
  return (
    <>
      <Container>
        <Box sx={attorneySectionStyle.scrollToAnchor} id="partneranwaelte">
          {" "}
        </Box>
        <AttorneySectionHeadings heading={heading} subheading={subheading} />
      </Container>
      {/*teamsection needs to be outside of container because the cards overlap if theres not enough width*/}
      {product === "settlement" ? (
        <TeamSection
          showHeadings={false}
          headline={"Sie möchten professionell gegen Ihre Kündigung angehen?"}
          subHeadline={"Wir kümmern uns persönlich um Sie"}
        />
      ) : (
        <TeamSection isSubsection={true} sectionPadding={true} headline={"Wir kümmern uns persönlich um Sie"} />
      )}
      <Container>
        <BirdMapSection />
        {textCards && <AttorneyTextCards />}
      </Container>
    </>
  );
};

export default AttorneySection;
